export const NOTIFICATION_TYPES = [
  { value: 'activity', text: 'Activity' },
  { value: 'promo', text: 'Promo' },
  { value: 'system', text: 'System' }
]

export const STATUS = [
  { value: 'active', text: 'Active' },
  { value: 'disabled', text: 'Disabled' },
]

export const SEGMENT_FIELDS = [
  { value: 'deposit.count', text: 'Deposit count' },
  { value: 'deposit.amount', text: 'Deposit amount' },
  { value: 'account.type', text: 'Account type' },
  { value: 'account.country', text: 'Account country' },
  { value: 'account.language', text: 'Account language' },
  { value: 'account.currency', text: 'Account currency' },
  { value: 'account.affiliate', text: 'Affiliate' },
  { value: 'account.btag', text: 'B-Tag' },
  { value: 'account.level', text: 'VIP Level' },
  { value: 'account.unfunded', text: 'Unfunded days' }
]

export const SEGMENT_EQUATION = [
  { value: '=', text: '=' },
  { value: '!=', text: '!=' },
  { value: '>', text: '>' },
  { value: '<', text: '<' },
  { value: '>=', text: '>=' },
  { value: '<=', text: '<=' },
  { value: 'in', text: 'in' },
  { value: 'notIn', text: 'not in' },
  { value: 'exists', text: 'exists' },
]

export const WEEKDAYS = [
  { value: 0, text: 'Sunday' },
  { value: 1, text: 'Monday' },
  { value: 2, text: 'Tuesday' },
  { value: 3, text: 'Wednesday' },
  { value: 4, text: 'Thursday' },
  { value: 5, text: 'Friday' },
  { value: 6, text: 'Saturday' },
]
export const AVAILABILITY_PERIODS = [
  { value: 'period', text: 'Period' },
  { value: 'monthday', text: 'Monthday' },
  { value: 'weekday', text: 'Weekday' },
  { value: 'daily', text: 'Daily' },
]
export const RECURRING_PERIODS = [
  { value: 'none', text: 'None' },
  { value: 'always', text: 'Always' },
  { value: 'custom', text: 'Custom' },
  { value: 'minute', text: 'Minute' },
  { value: 'hour', text: 'Hour' },
  { value: '24hours', text: '24 hours' },
  { value: 'day', text: 'Day' },
  { value: 'week', text: 'Week' },
  { value: 'month', text: 'Month' },
]

export const RECURRING_UNITS = [
  { value: 'years', text: 'Years' },
  { value: 'months', text: 'Months' },
  { value: 'weeks', text: 'Weeks' },
  { value: 'days', text: 'Days' },
  { value: 'hours', text: 'Hours' },
  { value: 'minutes', text: 'Minutes' },
  { value: 'seconds', text: 'Seconds' },
]

export const TTL = [
  { value: 'minute', text: 'Min' },
  { value: 'hour', text: 'Hour' },
  { value: 'day', text: 'Day' },
  { value: 'week', text: 'Week' },
  { value: 'month', text: 'Month' },
]
